const middleware = {}

middleware['301'] = require('../middleware/301.js')
middleware['301'] = middleware['301'].default || middleware['301']

middleware['i18n'] = require('../middleware/i18n.js')
middleware['i18n'] = middleware['i18n'].default || middleware['i18n']

export default middleware
